export default __webpack_public_path__ + "dab95bd557edbd743896439ca6fcb1cf.png";